import { render, staticRenderFns } from "./CustomerSOA.vue?vue&type=template&id=54012a3c&scoped=true"
import script from "./CustomerSOA.vue?vue&type=script&lang=js"
export * from "./CustomerSOA.vue?vue&type=script&lang=js"
import style0 from "./CustomerSOA.vue?vue&type=style&index=0&id=54012a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54012a3c",
  null
  
)

export default component.exports